











import FormField from '@/components/FormField'

export default {
    name: 'InputField'

    extends: FormField
}
